<template lang="pug">
  v-container#list.pr-0(fluid)
    v-flex.pr-0(xs12 v-bind:class="[searchDialogOpen ? 'modal' : 'no-modal']")
      v-card(flat)
        v-card-text.pb-0.small Busca palabras:
        v-card-title.py-0.searchbar
          v-text-field.px-3.search(
            v-model="search"
            append-icon="search"
            placeholder="Filtra los folios por palabra clave"
            hide-details
            class="input-group--focused"
          )
          v-card-actions(v-if="userPermissions.createReports && !searchDialogOpen")
            v-btn.add(
              fab
              dark
              @click="setCreateForm()"
            )
              v-icon(dark) add

        v-data-table.mt-4(
          :headers="headers"
          :items="filteredReportsForTable"
          :pagination.sync="pagination"
          expand
        )
          template(
            slot="items"
            slot-scope="props"
          )
            tr(@click="searchDialogOpen ? setAdvisoryNumber(props.item) : setRecord(props.item)", :class="selectedFolio == props.item.folio ? 'selected' : ''")
              td.bold.px-1 {{ props.item.folio }}
              td.text-xs-left.px-1 {{ props.item.petitioner.name }}
              td.text-xs-left.gray-text.px-1 {{ props.item.attention.attentionDate }}
              td.text-xs-left.px-1 {{ props.item.synthesis.state }}
              td.text-xs-left.px-1 {{ getMatter(props.item.synthesis.matter) }}
          v-alert(
            slot="no-results"
            :value="true"
            color="error"
            icon="warning"
          ) No se encontraron resultados.
</template>
<script>
import * as _ from "lodash";
export default {
  name: "List",
  props: {},
  data() {
    return {
      filteredReportsForTable: [],
      user: this.$store.state.user,
      search: "",
      pagination: {
        rowsPerPage: 15
      },
      headers: [
        {
          text: "Folio",
          align: "left",
          value: "folio"
        },
        { text: "Persona asesorada", value: "petitioner" },
        { text: "Último evento del caso", value: "attentionDate" },
        { text: "Estado", value: "state" },
        { text: "Asunto de la asesoría", value: "matter" }
      ],
      selectedFolio: ""
    };
  },
  computed: {
    userPermissions() {
      return this.$store.getters.user.permission;
    },
    reports() {
      return this.$store.getters.reports;
    },
    reportsForTable() {
      let reports = this.reports;
      return reports;
    },
    searchDialogOpen() {
      return this.$store.state.searchDialog;
    }
  },
  watch: {
    reportsForTable: async function(val) {
      this.filteredReportsForTable = val;
    },
    search: async function(val) {
      val = val.toLowerCase();
      if (this.search === "") {
        this.filteredReportsForTable = this.reportsForTable;
      } else {
        const filteredReportsForTable = await this.reportsForTable.filter(r => {
          return (
            r.folio.toString().includes(val) ||
            r.petitioner.name.toLowerCase().includes(val) ||
            r.attention.attentionDate.includes(val) ||
            r.synthesis.state.toLowerCase().includes(val) ||
            Object.keys(r.synthesis.matter)
              .filter(k => r.synthesis.matter[k].isSelected)
              .map(k => r.synthesis.matter[k].text)
              .join(", ")
              .toLowerCase()
              .includes(val)
          );
        });
        this.filteredReportsForTable = filteredReportsForTable;
      }
    }
  },
  methods: {
    setCreateForm: async function () {
      this.$store.commit("setEditionState", false);
      this.$store.commit("resetRecord");
      this.$store.commit("resetVictim");
      await this.$nextTick();
      this.$router.push("/form")
    },
    setRecord(record) {
      this.selectedFolio = record.folio;
      if (this.user.role === "Administración" || record.public === true) {
        this.$store.commit("setRecord", record);
        this.$store.commit("setVictims", record.victims);
      }
    },
    setAdvisoryNumber(item) {
      let type = "";
      let relatedRecords;
      let newAdvisoryNumber;

      if (item.relatedAdvisory === "") {
        relatedRecords = this.reports.filter(
          r => r.relatedAdvisory == item.folio
        );
        type = "main";
      } else {
        relatedRecords = this.reports.filter(
          r => r.relatedAdvisory == item.relatedAdvisory
        );
        type = "secondary";
      }
      relatedRecords = _.sortBy(relatedRecords, [
        o => o.attention.advisoryNumber
      ]);

      if (relatedRecords.length > 0) {
        let sumFloat =
          parseFloat(
            relatedRecords[relatedRecords.length - 1].attention.advisoryNumber
          ) + 0.1;
        newAdvisoryNumber = sumFloat.toFixed(1); 
      } else {
        newAdvisoryNumber = (item.attention.advisoryNumber + 0.1).toFixed(1);
      }
      let relatedFolio =
        type === "main"
          ? item.folio.toString()
          : relatedRecords[relatedRecords.length - 1].relatedAdvisory;

      this.$store.commit("updateAdvisoryNumber", parseFloat(newAdvisoryNumber));
      this.$store.commit("updateRelatedAdvisory", relatedFolio);
      this.$store.commit("updateSearchDialogStatus", false);
    },
    getReports() {
      this.$store.dispatch("getReports");
    },
    getMatter(matters) {
      let selectedMatters = [];
      _.forEach(matters, m => {
        if (m.isSelected) {
          selectedMatters.push(m.text);
        }
      });
      return selectedMatters.join(", ");
    }
  },
  mounted() {
    this.getReports();
  }
};
</script>
<style src="./list.scss" lang="scss"></style>
